<an-modal-container [open]="modalOpen" (onClose)="close()" [setting]="modalSetting"
  (onChangeBreakpoint)="changeBreakpoint($event)">
  <dt-progress-bar class="an-vdp-zipcode-modal-progress-bar" [setting]="progressBarSetting"></dt-progress-bar>
  <div class="an-vdp-zipcode-modal" *ngIf="verifyConfigData">

    <div class="content_container" [innerHTML]="zipCodeContent"> </div>
        

    <div class="title_container no-gutters">
    <div class="title_border col-sm-2"></div> <h2 class="an-vdp-zipcode-modal__title col-sm-7 zipcode-main-title"> {{ verifyConfigData.ModalTitleTxt }} </h2>
    <div class="title_border col-sm-2"></div></div>
    <h3 class="an-vdp-zipcode-modal__description"> {{ verifyConfigData.ModalDescriptionTxt }} </h3>

    <form [formGroup]="zipcodeForm" class="an-vdp-zipcode-modal__form invalid-form" (ngSubmit)="updateZipcode()">
      <div class="an-vdp-zipcode-modal__form-input"
        [ngClass]="{'an-vdp-zipcode-modal__form-input--invalid': isInvalidZipcode}">
        <label for="an-vdp-zipcode-modal-input" class="form-input__label"> {{ verifyConfigData.InputFieldDescriptionTxt
          }} </label>
        <input type="text" class="form-control" [ngClass]="{'is-invalid': isInvalidZipcode}"
          id="an-vdp-zipcode-modal-input" maxlength="5" formControlName="zipcode" allowOnlyNumbers>

          <img class="form-input__location-icon" (click)="getZipcode()" [src]="verifyConfigData.CurrentLocationIcon.Src"
          [alt]="verifyConfigData.CurrentLocationIcon.Alt">

        <div class="invalid-close" *ngIf="isInvalidZipcode" (click)="clearZipcode()"></div>
        <div class="invalid-feedback" *ngIf="isInvalidZipcode"> {{ getErrorMessage }} </div>
      </div>

      <button type="submit" class="an-vdp-zipcode-modal__submit-cta"> {{ verifyConfigData.SubmitCTATxt }} </button>
    </form>

  </div>

</an-modal-container>